module.exports = __webpack_public_path__ + "media/sofa.a7aa9295.mp4";